var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHassleFreePayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23626_18136)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 11.9166C9.16667 11.6735 9.26324 11.4403 9.43515 11.2684C9.60706 11.0965 9.84022 10.9999 10.0833 10.9999H29.3333C29.8196 10.9999 30.2859 10.8068 30.6297 10.4629C30.9735 10.1191 31.1667 9.65282 31.1667 9.16659C31.1667 8.68036 30.9735 8.21404 30.6297 7.87022C30.2859 7.52641 29.8196 7.33325 29.3333 7.33325H10.0833C8.86776 7.33325 7.70197 7.81614 6.84243 8.67568C5.98289 9.53522 5.5 10.701 5.5 11.9166V32.9999C5.5 33.9724 5.88631 34.905 6.57394 35.5926C7.26157 36.2803 8.19421 36.6666 9.16667 36.6666H34.8333C35.8058 36.6666 36.7384 36.2803 37.4261 35.5926C38.1137 34.905 38.5 33.9724 38.5 32.9999V16.4999C38.5 15.5275 38.1137 14.5948 37.4261 13.9072C36.7384 13.2196 35.8058 12.8333 34.8333 12.8333H10.0833C9.84022 12.8333 9.60706 12.7367 9.43515 12.5648C9.26324 12.3929 9.16667 12.1597 9.16667 11.9166ZM28.4167 27.4999C29.146 27.4999 29.8455 27.2102 30.3612 26.6945C30.8769 26.1787 31.1667 25.4793 31.1667 24.7499C31.1667 24.0206 30.8769 23.3211 30.3612 22.8054C29.8455 22.2896 29.146 21.9999 28.4167 21.9999C27.6873 21.9999 26.9878 22.2896 26.4721 22.8054C25.9564 23.3211 25.6667 24.0206 25.6667 24.7499C25.6667 25.4793 25.9564 26.1787 26.4721 26.6945C26.9878 27.2102 27.6873 27.4999 28.4167 27.4999Z",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23626_18136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHassleFreePayments);
export default __webpack_public_path__ + "static/media/hassle-free-payments.0a011a56b4cdcc85d082ef51b2c23373.svg";
export { ForwardRef as ReactComponent };